import { message } from "antd";
import { makeAutoObservable } from "mobx";
import { getEvents } from "../../apis/applicationApi";
import { DEMO_APP_ID } from "../../common/constants";
import { globalStores } from "../../GlobalStores";

/**
 * Danh sách event đã ghi nhận của app đang chọn, theo nền tảng.
 * Tải khi đổi app (AppSelector); dùng chung cho Overview, Engagement, Engagement Path, AB Testing, Referral.
 */
class ApplicationDetailStores {
  eventLoading = false;

  listEvents = [];
  listEventsMobile = [];
  listEventsIos = [];
  listEventsAndroid = [];
  listEventsWeb = [];

  constructor() {
    makeAutoObservable(this);
  }

  async getEvents(appId, partnerCode) {
    if (appId === DEMO_APP_ID) {
      return;
    }
    this.eventLoading = true;
    try {
      const events = await getEvents(appId, partnerCode);
      const eventAll = new Set();
      const eventIos = new Set();
      const eventAndroid = new Set();
      const eventMobile = new Set();
      const eventWeb = new Set();
      events.dataArray?.forEach((item) => {
        const newItem = JSON.stringify({
          key: item.key,
          partner_code: item.partner_code,
          partner_app_id: item.partner_app_id,
        });
        eventAll.add(newItem);
        if (item.channel === "IOS") {
          eventIos.add(newItem);
          eventMobile.add(newItem);
        } else if (item.channel === "ANDROID") {
          eventAndroid.add(newItem);
          eventMobile.add(newItem);
        } else if (item.channel === "WEB") {
          eventWeb.add(newItem);
        }
      });

      this.listEventsAndroid = Array.from(eventAndroid).map((item) => JSON.parse(item));
      this.listEventsIos = Array.from(eventIos).map((item) => JSON.parse(item));
      this.listEventsMobile = Array.from(eventMobile).map((item) => JSON.parse(item));
      this.listEventsWeb = Array.from(eventWeb).map((item) => JSON.parse(item));
      this.listEvents = Array.from(eventAll).map((item) => JSON.parse(item));
    } catch (error) {
      message.error(globalStores.t("An error occurred while retrieving data"));
    } finally {
      this.eventLoading = false;
    }
  }
}

export const applicationDetailStores = new ApplicationDetailStores();
